import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import QuantityControl from "../helper/QuantityControl";
import { useNavigate } from "react-router-dom";


const CartSection = () => {
    const navigate = useNavigate();
    const [cart, setCart] = useState(null);
    const [loading, setLoading] = useState(true);

    const BASE_URL =
        "https://ecom.brightcodeapp.com/wp-json/wc/store/cart";

    /* =========================
       FETCH CART
    ========================= */
    const fetchCart = async () => {
        try {
            const cartToken = localStorage.getItem("cart_token");

            const res = await fetch(BASE_URL, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    ...(cartToken && { "Cart-Token": cartToken }),
                },
            });

            const newCartToken = res.headers.get("Cart-Token");

            if (newCartToken) {
                localStorage.setItem("cart_token", newCartToken);
            }

            const data = await res.json();

            setCart(data);
            setLoading(false);

            // update header cart count
            window.dispatchEvent(new Event("cartUpdated"));
        } catch (error) {
            console.error("Cart fetch error:", error);
            setLoading(false);
        }
    };

    /* =========================
       UPDATE QUANTITY
    ========================= */
    const updateQuantity = async (key, quantity) => {
        try {
            const cartToken = localStorage.getItem("cart_token");

            const res = await fetch(
                `${BASE_URL}/update-item`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...(cartToken && { "Cart-Token": cartToken }),
                    },
                    body: JSON.stringify({
                        key: key,
                        quantity: quantity,
                    }),
                }
            );

            const newCartToken = res.headers.get("Cart-Token");

            if (newCartToken) {
                localStorage.setItem("cart_token", newCartToken);
            }

            await fetchCart();
        } catch (error) {
            console.error("Update quantity error:", error);
        }
    };

    
    const handleClick = () => {
    const token = localStorage.getItem("token"); // check login
    if (token) {
      navigate("/checkout"); // user logged in → go to checkout
    } else {
      navigate("/account"); // not logged in → redirect to login/account
    }};
    

    /* =========================
       REMOVE ITEM
    ========================= */
    const removeItem = async (key) => {
        try {
            const cartToken = localStorage.getItem("cart_token");

            const res = await fetch(
                `${BASE_URL}/remove-item`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...(cartToken && { "Cart-Token": cartToken }),
                    },
                    body: JSON.stringify({
                        key: key,
                    }),
                }
            );

            const newCartToken = res.headers.get("Cart-Token");

            if (newCartToken) {
                localStorage.setItem("cart_token", newCartToken);
            }

            await fetchCart();
        } catch (error) {
            console.error("Remove item error:", error);
        }
    };

    /* =========================
       LOAD CART
    ========================= */
    useEffect(() => {
        fetchCart();
    }, []);

    /* =========================
       LOADING
    ========================= */
    if (loading)
        return (
            <p className="text-center py-80">
                Loading cart...
            </p>
        );

    /* =========================
       EMPTY CART
    ========================= */
    if (!cart || cart.items.length === 0)
        return (
            <p className="text-center py-80">
                Your cart is empty
            </p>
        );

    /* =========================
       UI
    ========================= */
    return (
        <section className="cart py-80">
            <div className="container container-lg">
                <div className="row gy-4">

                    {/* LEFT TABLE */}
                    <div className="col-xl-9 col-lg-8">
                        <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">

                                <table className="table style-three">
                                    <thead>
                                        <tr>
                                            <th>Delete</th>
                                            <th>Product Name</th>
                                            <th>Price</th>
                                            <th>Quantity</th>
                                            <th>Subtotal</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {cart.items.map((item) => (
                                            <tr key={item.key}>

                                                {/* REMOVE */}
                                                <td>
                                                    <button
                                                        onClick={() =>
                                                            removeItem(item.key)
                                                        }
                                                        className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                                                    >
                                                        <i className="ph ph-x-circle text-2xl d-flex" />
                                                        Remove
                                                    </button>
                                                </td>

                                                {/* PRODUCT */}
                                                <td>
                                                    <div className="table-product d-flex align-items-center gap-24">

                                                        <Link
                                                            to={`/product-details/${item.id}`}
                                                            className="table-product__thumb border border-gray-100 rounded-8 flex-center"
                                                        >
                                                            <img
                                                                src={
                                                                    item.images?.[0]?.src
                                                                }
                                                                alt={item.name}
                                                                width="80"
                                                            />
                                                        </Link>

                                                        <div className="table-product__content text-start">
                                                            <h6 className="title text-lg fw-semibold mb-8">
                                                                {item.name}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* PRICE */}
                                                <td>
                                                    <span className="text-lg fw-semibold">
                                                        ₹
                                                        {(
                                                            item.prices.price /
                                                            100
                                                        ).toFixed(2)}
                                                    </span>
                                                </td>

                                                {/* QUANTITY */}
                                                <td>
                                                    <QuantityControl
                                                        initialQuantity={
                                                            item.quantity
                                                        }
                                                        onIncrease={() =>
                                                            updateQuantity(
                                                                item.key,
                                                                item.quantity + 1
                                                            )
                                                        }
                                                        onDecrease={() =>
                                                            item.quantity > 1 &&
                                                            updateQuantity(
                                                                item.key,
                                                                item.quantity - 1
                                                            )
                                                        }
                                                    />
                                                </td>

                                                {/* SUBTOTAL */}
                                                <td>
                                                    <span className="text-lg fw-semibold">
                                                        ₹
                                                        {(
                                                            item.totals.line_total /
                                                            100
                                                        ).toFixed(2)}
                                                    </span>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>

                                </table>

                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDEBAR */}
                    <div className="col-xl-3 col-lg-4">
                        <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">

                            <h6 className="text-xl mb-32">
                                Cart Totals
                            </h6>

                            <div className="bg-color-three rounded-8 p-24">

                                <div className="flex-between mb-32">
                                    <span>Subtotal</span>
                                    <span>
                                        ₹
                                        {(
                                            cart.totals.total_items /
                                            100
                                        ).toFixed(2)}
                                    </span>
                                </div>

                                <div className="flex-between">
                                    <span>Total</span>

                                    <span className="fw-semibold">
                                        ₹
                                        {(
                                            cart.totals.total_price /
                                            100
                                        ).toFixed(2)}
                                    </span>
                                </div>

                            </div>

                            <button
                                className="btn btn-main mt-40 py-18 w-100 rounded-8"
                                onClick={handleClick}
                            >
                                Proceed to checkout
                            </button>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default CartSection;
